import { message } from 'antd';
import axios from 'axios';
import { LOCAL_STORAGE_KEYS } from '../constants/AppConstants';
import firebase from 'firebase/compat/app';

export const BuildMode = {
  BUILD_MODE_DEV: 'dev',
  BUILD_MODE_QA: 'qa',
  BUILD_MODE_STAGING: 'staging',
  BUILD_MODE_PROD: 'prod',
};

export class AppEnvironment {
  showEvironmentSelector = false;
  static buildMode = null;
  static config = {};
  static versionString = '';
  static validVersion = '';
  static configure(config = {}) {
    AppEnvironment.buildMode = config.BUILD_MODE;
    AppEnvironment.config = config;
  }
}


// Grab the baseURL from the AppEnvironment
const baseURL = AppEnvironment.config.baseURL;

console.log('base URL in ApiClient = ' + baseURL);

// -------------------- NEW WAY: Create an Axios instance -------------------- //
const instance = axios.create({

  //baseURL: () => AppEnvironment.config.baseURL,
    //baseURL,

  headers: {
    'Content-Type': 'application/json',
  },
});


// -------------------- Request Interceptor: attach token -------------------- //
instance.interceptors.request.use(
    async (config) => {
      // If user is logged in, get a fresh token from Firebase
      config.baseURL = AppEnvironment.config.baseURL;
      console.log("baseURL in request.use = " + AppEnvironment.config.baseURL);
      const currentUser = firebase.auth().currentUser;
      if (currentUser) {
        // Firebase caches valid tokens, so this won't always be a network call
        const token = await currentUser.getIdToken(/* forceRefresh */ false);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => {
      // Request error
      return Promise.reject(error);
    }
);


// -------------------- Response Interceptor: handle 401 -------------------- //
instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        message.error('You are not allowed to access this resource.');
        // sign out user from Firebase
        await firebase.auth().signOut();
        // optionally clear localStorage if your app stores other things there
        window.localStorage.clear();
        window.location.href = '/sign-in';
      }
      return Promise.reject(error);
    }
);



// -------------------- Export an object with convenience methods -------------------- //
export const apiClient = {
    get: (url, options = {}) => instance.get(url, options),
    post: (url, data, options = {}) => instance.post(url, data, options),
    uploadImage: (url, data, options = {}) => instance.post(url, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...options,
    }),
    put: (url, data, options = {}) => instance.put(url, data, options),
    patch: (url, data, options = {}) => instance.patch(url, data, options),
    delete: (url, data, options = {}) => instance.delete(url, { data, ...options }),
};

